import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "q-pr-sm" }
const _hoisted_2 = {
  key: 0,
  class: "text-subtitle1"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "q-pr-sm" }
const _hoisted_5 = {
  key: 0,
  class: "text-subtitle1"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "q-pr-sm" }
const _hoisted_8 = {
  key: 0,
  class: "text-subtitle1"
}
const _hoisted_9 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_10 = { class: "q-pr-sm" }
const _hoisted_11 = {
  key: 0,
  class: "text-subtitle1"
}
const _hoisted_12 = {
  key: 1,
  class: "text-primary"
}

import { onMounted, computed } from "vue";
  import { useQuasar } from "quasar";

  import { useAuthStore } from "src/stores/auth-store";
  import { useSettingsStore } from "src/stores/settings-store";

  import { useOpenUrl, EVENTS, logEvent } from "src/functions";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Help',
  setup(__props) {

  const q = useQuasar();
  const authStore = useAuthStore();
  const settingsStore = useSettingsStore();

  onMounted(() => {
    logEvent(EVENTS.HELP_VIEW);
  })

  function logout() {
    authStore.logout(true);
  }

  const isMobile = computed(() => settingsStore.isMobile)

  function openFaq() {
    useOpenUrl("https://www.carfinance247.co.uk/faq");
  }

  function openPhone() {
    window.open('tel:' + settingsStore.contactNumber)
  }

  const whatsAppMessage = computed(() => {
    const n = settingsStore.whatsAppNumber.replace(/\s/g, '').substr(1);
    return `whatsapp://send?phone=+44${n}`
  })

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_img, {
      src: require('assets/img/dealer-help-image.png')
    }, null, 8, ["src"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "text-h4 q-pb-xs q-px-md",
      "data-cy": "helpText"
    }, " We're here to help ", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-body1 q-px-md q-pb-lg q-pt-sm" }, " Our dealer support team is on hand to answer any questions you have. ", -1)),
    _createVNode(_component_q_list, {
      bordered: isMobile.value,
      separator: isMobile.value,
      dense: !isMobile.value
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          outlined: "",
          href: 'tel:' + _unref(settingsStore).contactNumber,
          class: "q-px-md q-py-md flex justify-start items-center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_icon, {
                name: "o_call",
                class: "icon-md"
              })
            ]),
            _createVNode(_component_q_item_section, { class: "text-body1" }, {
              default: _withCtx(() => [
                (isMobile.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Call Us"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(settingsStore).contactNumber), 1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["href"])), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          class: "q-px-md q-py-md items-center",
          href: whatsAppMessage.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "fa-brands fa-whatsapp",
                class: "icon-md"
              })
            ]),
            _createVNode(_component_q_item_section, { class: "text-body1" }, {
              default: _withCtx(() => [
                (isMobile.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Send us a WhatsApp"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(settingsStore).whatsAppNumber), 1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["href"])), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          outlined: "",
          class: "q-px-md q-py-md items-center",
          href: 'mailto:'+_unref(settingsStore).contactEmail
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_q_icon, {
                name: "o_email",
                class: "icon-md"
              })
            ]),
            _createVNode(_component_q_item_section, { class: "text-body1" }, {
              default: _withCtx(() => [
                (isMobile.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Email Us"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(settingsStore).contactEmail), 1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["href"])), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          outlined: "",
          class: "q-px-md q-py-md items-center",
          onClick: openFaq
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_q_icon, {
                name: "mdi-help-circle-outline",
                class: "icon-md"
              })
            ]),
            _createVNode(_component_q_item_section, { class: "text-body1" }, {
              default: _withCtx(() => [
                (isMobile.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "FAQs"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, "Read the FAQs"))
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ])
      ]),
      _: 1
    }, 8, ["bordered", "separator", "dense"])
  ], 64))
}
}

})